import type {
  ChangeExpiredPasswordRequest,
  ChangeExpiredPasswordResponse,
} from "../types/auth.type";
import type { IAuthRepository } from "../repositories/AuthRepository";
import { assertPasswordComplexity } from "../utils/passwordValidation";

export interface IChangeExpiredPasswordUseCase {
  execute(
    request: ChangeExpiredPasswordRequest,
  ): Promise<ChangeExpiredPasswordResponse>;
}

export class ChangeExpiredPasswordUseCase implements IChangeExpiredPasswordUseCase {
  constructor(private readonly authRepository: IAuthRepository) {}

  async execute(
    request: ChangeExpiredPasswordRequest,
  ): Promise<ChangeExpiredPasswordResponse> {
    if (!request.email || !request.currentPassword || !request.newPassword) {
      throw new Error("Email, current password, and new password are required");
    }

    if (request.newPassword !== request.newPassword.trim()) {
      throw new Error("New password cannot contain leading or trailing spaces");
    }

    assertPasswordComplexity(request.newPassword);

    return this.authRepository.changeExpiredPassword({
      email: request.email.trim().toLowerCase(),
      currentPassword: request.currentPassword,
      newPassword: request.newPassword,
    });
  }
}

export const createChangeExpiredPasswordUseCase = (
  authRepository: IAuthRepository,
): ChangeExpiredPasswordUseCase => {
  return new ChangeExpiredPasswordUseCase(authRepository);
};
